import styled from 'styled-components'

export const TrendsWidgetContent = styled.div`
    margin: 0 17px;
`
